import {
  initialState,
  Actions,
  State,
  GET_COMMENTS,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
  RESET_COMMENTS,
} from '../../types/comment/get-comments';
import { CommentDto } from '../../../types/comment.dto';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMMENTS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMMENTS_SUCCESS: {
      // If appending (load more), merge with existing top-level comments
      const existingItems = action.append && state.data ? state.data.data : [];
      const newItems = action.payload.data;

      // Deduplicate by id
      const mergedMap = new Map<number, CommentDto>();
      [...existingItems, ...newItems].forEach((c) => mergedMap.set(c.id, c));
      const mergedItems = Array.from(mergedMap.values());

      return {
        ...state,
        data: {
          data: mergedItems,
          pagination: action.payload.pagination,
        },
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    }
    case GET_COMMENTS_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_COMMENTS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
